import axios from "axios";
import { ACCOUNTS_URL, API_BASE_URL, ACCOUNTS_TYPES_URL, ACCOUNTING_PLAID_SYSTEM_PAYMENTS, ACCOUNTING_PLAID_MATCH_PAYMENTS, ACCOUNTING_PLAID_SYSTEM_SPENT_RECORDS, ACCOUNTING_PLAID_SYSTEM_DEPOSITS } from "../../../../../constants/config";

export function getUnlinkedBankAccounts(params) {
    return axios.get(`${ACCOUNTS_URL}/accounts/list`, { params });
}

export function getSuppliers(params) {
    return axios.get(`${API_BASE_URL}/inventory/suppliers/list2`, { params });
}

export function getCustomers(params) {
    return axios.get(`${API_BASE_URL}/sale/customers/list2`, { params });
}

// Get account types tree
export function getAccountTypesTree() {
    return axios.get(`${ACCOUNTS_TYPES_URL}/tree`);
}

// Get Plaid link token. Pass { plaid_item_id } to get an update-mode token, which
// reopens Link against an existing connection instead of adding a new one.
export function getPlaidLinkToken(params) {
    return axios.get(`${API_BASE_URL}/accounting/plaid/link-token`, { params });
}

// Stop syncing a connection without unlinking it.
export function pausePlaidConnection(plaidItemId) {
    return axios.post(`${API_BASE_URL}/accounting/plaid/item/${plaidItemId}/pause`);
}

// Resume a paused connection; the server queues the catch-up sync.
export function resumePlaidConnection(plaidItemId) {
    return axios.post(`${API_BASE_URL}/accounting/plaid/item/${plaidItemId}/resume`);
}

// Pull fresh transactions from Plaid. Omit plaid_item_ids to sync every active connection.
export function syncPlaidConnections(payload = {}) {
    return axios.post(`${API_BASE_URL}/accounting/plaid/sync`, payload);
}

// Exchange Plaid public token
export function exchangePlaidToken(payload) {
    return axios.post(`${API_BASE_URL}/accounting/plaid/exchange-token`, payload);
}

// Get Plaid transactions
export function getPlaidTransactions(payload) {
    return axios.post(`${API_BASE_URL}/accounting/expenses/plaid/transactions/get`, payload);
}

// Get local accounts
export function getPlaidAccounts(params) {
    return axios.get(`${API_BASE_URL}/accounting/plaid/account/list`, { params });
}

export function getUnlinkedPlaidAccounts(params = {}) {
    return axios.get(`${API_BASE_URL}/accounting/plaid/account/list`, { params: { ...params, unlinked: true } });
}

export function linkPlaidAccounts(payload) {
    return axios.post(`${API_BASE_URL}/accounting/plaid/link-accounts`, payload);
}

export function getLocalTransactions(params) {
  const { filter, search, account_ids, _refresh, ...rest } = params;
  const accountIds = Array.isArray(account_ids)
    ? account_ids.join(",")
    : account_ids;

  return axios.get(
    `${API_BASE_URL}/accounting/plaid/transaction/list`,
    {
      params: {
        ...rest,
        ...(accountIds
          ? { account_ids: accountIds }
          : []),
        search_key: Array.isArray(search) ? search.join(" ") : search,
        transaction_filter: filter,
      },
    }
  );
}

// Update Plaid transaction
export function updatePlaidTransaction(payload) {
    return axios.put(`${API_BASE_URL}/accounting/plaid/transaction/update`, payload);
}

export function getPlaidTransferSuggestedMatches(params) {
    return axios.get(`${API_BASE_URL}/accounting/plaid/transfer/suggested-matches`, { params });
}

// Void expense
export function voidExpense(expenseId) {
    return axios.put(`${API_BASE_URL}/accounting/expenses/${expenseId}/void`);
}

// Get transaction by ID
export function getTransactionById(transactionId) {
    return axios.get(`${API_BASE_URL}/accounting/expenses/plaid/transaction/${transactionId}`);
}

// Get transactions by IDs
export function getTransactionsByIds(payload) {
    return axios.post(`${API_BASE_URL}/accounting/expenses/plaid/transactions/by-ids`, payload);
} 

export function getPaymentMatchesWithPlaid(params) {
    return axios.get(`${ACCOUNTING_PLAID_SYSTEM_PAYMENTS}`, { params });
}

export function matchPaymentWithPlaid(payload) {
    return axios.post(`${ACCOUNTING_PLAID_MATCH_PAYMENTS}`, payload);
}

export function undoPaymentWithPlaid(payload) {
    return axios.post(`${ACCOUNTING_PLAID_MATCH_PAYMENTS}/undo`, payload);
}
export function undoSpentWithPlaid(payload) {
    return axios.post(`${ACCOUNTING_PLAID_MATCH_PAYMENTS}/spent-undo`, payload);
}

export function getPaymentMatchesWithPlaidForCredit(params) {
    return axios.get(`${ACCOUNTING_PLAID_SYSTEM_SPENT_RECORDS}`, { params });
}
export function matchSpentWithPlaid(payload) {
    return axios.post(`${ACCOUNTING_PLAID_MATCH_PAYMENTS}/spent`, payload);
}

// Deposits available to match against a received (DEBIT) bank line.
export function getDepositMatchesWithPlaid(params) {
    return axios.get(`${ACCOUNTING_PLAID_SYSTEM_DEPOSITS}`, { params });
}
// Match a received bank line to a whole Deposit record.
export function matchDepositWithPlaid(payload) {
    return axios.post(`${ACCOUNTING_PLAID_MATCH_PAYMENTS}/deposit`, payload);
}
// Undo a deposit match.
export function undoDepositWithPlaid(payload) {
    return axios.post(`${ACCOUNTING_PLAID_MATCH_PAYMENTS}/deposit-undo`, payload);
}

// Bulk action: per-line readiness (single exact match / categorize / reason).
export function bulkActionPreviewWithPlaid(payload) {
    return axios.post(`${API_BASE_URL}/accounting/plaid/bulk-action/preview`, payload);
}
// Bulk action: apply match/categorize per line; skipped lines return a reason.
export function bulkActionWithPlaid(payload) {
    return axios.post(`${API_BASE_URL}/accounting/plaid/bulk-action`, payload);
}
